import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faUserFriends, faChartLine, faCog } from '@fortawesome/free-solid-svg-icons';

function NavBarBottom() {
  return (
    <nav className="w-full bg-white border-t border-gray-100 rounded-b-2xl flex justify-between items-center px-2 py-1 mt-2">
      <div className="flex flex-col items-center flex-1 text-blue-600">
        <FontAwesomeIcon icon={faHome} />
        <span className="text-xs">Accueil</span>
      </div>
      <div className="flex flex-col items-center flex-1 text-gray-400">
        <FontAwesomeIcon icon={faUserFriends} />
        <span className="text-xs">Relations</span>
      </div>
      <div className="flex flex-col items-center flex-1 text-gray-400">
        <FontAwesomeIcon icon={faChartLine} />
        <span className="text-xs">Activité</span>
      </div>
      <div className="flex flex-col items-center flex-1 text-gray-400">
        <FontAwesomeIcon icon={faCog} />
        <span className="text-xs">Paramètres</span>
      </div>
    </nav>
  );
}

export default NavBarBottom; 